import React from 'react';
import { Route, Switch } from 'react-router';

import { RequireRole } from '../containers/RequireRole';
import Home from '../components/Home';
import SignIn from '../containers/SignIn';
import Forbidden from '../components/Forbidden';

/* 
  User Routes
*/
import Users from '../containers/Users';
import EditUser from '../containers/Users/EditUser';
import ViewUser from '../containers/Users/ViewUser';

/* 
  Posts Routes
*/
import AddPost from '../containers/Posts/AddPost';
import Posts from '../containers/Posts';
import ViewPost from '../containers/Posts/ViewPost';
import EditPost from '../containers/Posts/EditPost';
import RoomerPost from '../components/Posts/RoomerPost';

/* 
  Property Routes
*/

import AddProperty from '../containers/Property/AddProperty';
import Property from '../containers/Property';
import ViewProperty from '../containers/Property/ViewProperty';
import EditProperty from '../containers/Property/EditProperty';

/* 
  Endrosment Routes
*/
import AddEndrosment from '../containers/Endrosments/AddEndrosment';
import EditEndrosment from '../containers/Endrosments/EditEndrosment';
import Endrosments from '../containers/Endrosments';

import Broadcast from '../containers/Broadcast';
import UpdatePassword from '../containers/UpdatePassword';
import TravelGUpdatePassword from '../containers/TravelGUpdatePassword';
import RequestRecommendation from '../containers/RequestRecommendation';
import ShowProfile from '../containers/ShowProfile';
import VacancyShare from '../containers/VacancyShare';
import PostShare from '../containers/PostShare';
import RedirectApp from '../components/RedirectApp';
import PrivacyPolicy from '../containers/PrivacyPolicy';
import Terms from '../containers/Terms';
import ViewRoomerPost from '../containers/Posts/ViewRoomerPost';
import EditRoomerPost from '../containers/Posts/EditRoomerPost';

const routes = (
  <div>
    <Switch>
      <Route exact path="/dashboard" component={RequireRole(Home,
      { requiredRole: 3, onlyAdmin: true } )} />
      <Route exact path="/" component={RequireRole(Home,
      { requiredRole: 3, onlyAdmin: true } )} />
      <Route exact path="/login" component={SignIn}/>
      <Route exact path="/forbidden" component={RequireRole(Forbidden,
      { requiredRole: 3, onlyAdmin: true } )}/>
      
      <Route exact path="/users" component={RequireRole(Users,
      { requiredRole: 3, onlyAdmin: true } )}/>
      <Route exact path="/users/:roleId" component={RequireRole(Users,
      { requiredRole: 3, onlyAdmin: true } )}/>
      <Route exact path="/user/edit-user/:userId" component={RequireRole(EditUser,
      { requiredRole: 3, onlyAdmin: true } )}/>
      <Route exact path="/user/view-user/:userId" component={RequireRole(ViewUser,
      { requiredRole: 3, onlyAdmin: true } )}/>
      
      <Route exact path="/posts" component={RequireRole(Posts,
      { requiredRole: 3, onlyAdmin: true } )}/>
      <Route exact path="/posts/new" component={RequireRole(AddPost,
      { requiredRole: 3, onlyAdmin: true } )}/>
      <Route exact path="/posts/view-post/:postId" component={RequireRole(ViewPost,
      { requiredRole: 3, onlyAdmin: true } )}/>
      <Route exact path="/posts/edit-post/:postId" component={RequireRole(EditPost,
      { requiredRole: 3, onlyAdmin: true } )}/>
      <Route exact path="/roomer-post" component={RequireRole(RoomerPost,
      { requiredRole: 3, onlyAdmin: true } )}/>
      <Route exact path="/roomer-post/view/:postId" component={RequireRole(ViewRoomerPost,
      { requiredRole: 3, onlyAdmin: true } )}/>
      <Route exact path="/edit-roomer-post/:postId" component={RequireRole(EditRoomerPost,
      { requiredRole: 3, onlyAdmin: true } )}/>

      <Route exact path="/property" component={RequireRole(Property,
      { requiredRole: 3, onlyAdmin: true } )}/>
      <Route exact path="/property/new" component={RequireRole(AddProperty,
      { requiredRole: 3, onlyAdmin: true } )}/>
      <Route exact path="/property/view-property/:id" component={RequireRole(ViewProperty,
      { requiredRole: 3, onlyAdmin: true } )}/>
      <Route exact path="/property/edit-property/:id" component={RequireRole(EditProperty,
      { requiredRole: 3, onlyAdmin: true } )}/>
      
      <Route exact path="/endrosments" component={RequireRole(Endrosments,
      { requiredRole: 3, onlyAdmin: true } )}/>
      <Route exact path="/endrosment/new" component={RequireRole(AddEndrosment,
      { requiredRole: 3, onlyAdmin: true } )}/>
      <Route exact path="/endrosment/edit-endrosment/:id" component={RequireRole(EditEndrosment,
      { requiredRole: 3, onlyAdmin: true } )} />

      <Route exact path="/broadcast" component={RequireRole(Broadcast,
      { requiredRole: 3, onlyAdmin: true } )} />
      
      <Route exact path="/update-password/:id" component={UpdatePassword} />

      <Route exact path="/travelg/update-password/:id" component={TravelGUpdatePassword} />

      <Route exact path="/request-recommendation/:id" component={RequestRecommendation} />

      <Route exact path="/view-profile/:id" component={ShowProfile} />
      <Route exact path="/vacancy-share/:id" component={VacancyShare} />
      <Route exact path="/post-share/:id" component={PostShare} />
      <Route exact path="/redirect-app" component={RedirectApp} />
      {/* <Route exact path="/privacy-policy" component={PrivacyPolicy} /> */}
      <Route exact path="/privacy-policy-new" component={PrivacyPolicy} />
      <Route exact path="/terms" component={Terms} />
    </Switch>
  </div>
);

export default routes;